import { Card } from "@mantine/core";
import { ReactChildren } from "../../../services/model/types";

type InputType = {
  withBorder?: boolean;
  height?: number;
  className?: string;
};

export function MyCard(props: ReactChildren & InputType) {
  return (
    <Card
      radius="xl"
      shadow="xl"
      withBorder={props.withBorder}
      className={`p-0 relative my-6 ${props.className}`}
      style={{ width: 400, height: props.height }}
    >
      {props.children}
    </Card>
  );
}
